module.exports = __webpack_public_path__ + "static/media/bdot_featured_item.65acb040.webp";